export default __webpack_public_path__ + "static/media/MagicDays.bfe4fd2f.png";